import { render } from "./productSupplier.vue?vue&type=template&id=d6757af4"
import script from "./productSupplier.vue?vue&type=script&lang=js"
export * from "./productSupplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/purchase/components/productSupplier.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6757af4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6757af4', __exports__)) {
    api.reload('d6757af4', __exports__)
  }
  
  module.hot.accept("./productSupplier.vue?vue&type=template&id=d6757af4", () => {
    api.rerender('d6757af4', render)
  })

}


export default __exports__